import styled from "styled-components";

// components
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

export const BankInfo = styled.div(({ theme }) => ({
    display: "flex",
    marginBottom: theme.spacing.medium,
    alignItems: "flex-start",
    paddingBottom: theme.spacing.small,
    borderBottom: `1px dashed ${theme.colors[theme.colorMode].border_Subtle_Secondary}`,
}));

export const BankInfoImage = styled(Image)(() => ({
    width: "40px",
    height: "40px",
}));

export const BankInfoText = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
    flex: 1,
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-start",
}));

export const BankInfoDesc = styled.div(() => ({
    display: "flex",
    alignItems: "flex-start",
}));

export const SubText = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
}));

export const Content = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));

export const TnCButton = styled(TextButton)(({ theme }) => ({
    width: "fit-content",
    padding: theme.spacing.empty,
}));

export const StyledCardContainer = styled(CardContainer)(({ theme }) => ({
    zIndex: theme.spacing.empty,
    margin: `calc(-1 * ${theme.spacing.medium}) ${theme.spacing.xxSmall}`,
    position: "relative",

    "&::after": {
        content: '""',
        position: "absolute",
        left: "-1px",
        right: "-1px",
        bottom: `-30px`,
        height: `30px`,
        backgroundImage: `linear-gradient(45deg, ${theme.colors[theme.colorMode].background_Primary} 50%, transparent 0), linear-gradient(-45deg, ${theme.colors[theme.colorMode].background_Primary} 50%, transparent 0)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0px 20px, 40px 20px",
        backgroundRepeat: "repeat-x",
        transform: "rotate(180deg)",
    },
}));
